var map = {
	"./template.bet575": 1915,
	"./template.bet575.tsx": 1915,
	"./template.bet777": 1916,
	"./template.bet777.tsx": 1916,
	"./template.betblast": 1917,
	"./template.betblast.tsx": 1917,
	"./template.betgalaxy": 1918,
	"./template.betgalaxy.tsx": 1918,
	"./template.betprofessor": 1919,
	"./template.betprofessor.tsx": 1919,
	"./template.betroyale": 2023,
	"./template.betroyale.tsx": 2023,
	"./template.betstride": 1920,
	"./template.betstride.tsx": 1920,
	"./template.buffalobet": 1921,
	"./template.buffalobet.tsx": 1921,
	"./template.chromabet": 1922,
	"./template.chromabet.tsx": 1922,
	"./template.default": 181,
	"./template.default.tsx": 181,
	"./template.fiestabet": 1923,
	"./template.fiestabet.tsx": 1923,
	"./template.forsport": 2139,
	"./template.forsport.tsx": 2139,
	"./template.gigabet": 1924,
	"./template.gigabet.tsx": 1924,
	"./template.goldenbet888": 1925,
	"./template.goldenbet888.tsx": 1925,
	"./template.goldenrush": 1926,
	"./template.goldenrush.tsx": 1926,
	"./template.hyperbet": 1927,
	"./template.hyperbet.tsx": 1927,
	"./template.juicybet": 1928,
	"./template.juicybet.tsx": 1928,
	"./template.junglebet": 1929,
	"./template.junglebet.tsx": 1929,
	"./template.magnumbet": 1930,
	"./template.magnumbet.tsx": 1930,
	"./template.puntcity": 2140,
	"./template.puntcity.tsx": 2140,
	"./template.puntgenie": 1931,
	"./template.puntgenie.tsx": 1931,
	"./template.pyramidbet": 1932,
	"./template.pyramidbet.tsx": 1932,
	"./template.questbet": 1933,
	"./template.questbet.tsx": 1933,
	"./template.slambet": 1934,
	"./template.slambet.tsx": 1934,
	"./template.sterlingparker": 1935,
	"./template.sterlingparker.tsx": 1935,
	"./template.templebet": 1936,
	"./template.templebet.tsx": 1936,
	"./template.titanbet": 1937,
	"./template.titanbet.tsx": 1937,
	"./template.ts": 999,
	"./template.vikingbet": 1938,
	"./template.vikingbet.tsx": 1938,
	"./template.volcanobet": 1939,
	"./template.volcanobet.tsx": 1939,
	"./template.wellbet": 2141,
	"./template.wellbet.tsx": 2141
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2787;